import { Extensions } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import Underline from '@tiptap/extension-underline';
import Link from '@tiptap/extension-link';
import TextAlign from '@tiptap/extension-text-align';

import { ResizableImage } from './ResizableImage';
import { LinkUi } from './LinkUi';

export function getExtensions(): Extensions {
  return [
    StarterKit,
    ResizableImage.configure({ inline: true }),
    Link.configure({
      autolink: false,
      openOnClick: false,
      linkOnPaste: false,
    }),
    LinkUi,
    TextAlign.configure({
      types: ['heading', 'paragraph'],
    }),
    Underline,
  ];
}
